
/**
 * ###### 2019-04-01
 * @name axios 基于axios的Ajax异步请求方法的封装
 * @description 核心方法基于axios
 * @author	吕陇平
 * @return 返回axios的实例，需要的时候直接引用
 *
 */

import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant'

axios.defaults.withCredentials = false
axios.defaults.baseURL = URL_PREFIX_SERVICE
// axios 配置
axios.defaults.timeout = 4000// 等待时长
let userId = localStorage.getItem('userId')
let uuid = localStorage.getItem('uuid')
if (userId == 'undefined') {
    userId = 0
}
axios.interceptors.request.use(
    config => {
        config.headers = {
            // 'Content-Type': 'text/plain'
            // 'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8'
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        config.data = {
            ...config.data,
            "userUuid": uuid,
            'userId': userId ? userId : 0
        }
        return config
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

// 添加响应拦截器
axios.interceptors.response.use(
    res => {
        if (res.status == 200) {
            if (res.data.status) {
                if (res.data.status.code == '0') {
                    return res.data
                } else {
                    if (res.data.status.code === "04520003") {
                        Toast.error("已超时")
                    } else {
                        // 错误信息提示
                        Toast(res.data.status.description)
                        // Toast({
                        //     message: res.data.status.description,
                        //     duration: 60000
                        // })
                    }
                }

            } else {
                return res.data
            }
        }
    },
    error => {
        // 请求错误时做些事
        return Promise.reject(error)
    }
)
axios.defaults.transformRequest = data => {
    if (typeof data === 'object' && !data.append) {
        return qs.stringify(data)
    } else {
        return data
    }
}
axios.plugin = {
    install(Vue) {
        Object.defineProperty(Vue.prototype, '$axios', { value: axios })
    }
}
export default axios


// WEBPACK FOOTER //
// ./src/assets/js/axios.js